import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Capabilities', path: '/services' },
    { label: 'Quality', path: '/quality' },
    { label: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: '#fff',
        color: '#333',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Toolbar>
        {/* Logo */}
        <Box component={Link} to="/" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', textDecoration: 'none' }}>

          <Box component="img" src="/images/logo.png" alt="Ayda India Logo" sx={{ height: { xs: 30, sm: 40, md: 50 }, width: 'auto', objectFit: 'contain', mr: { xs: 1, md: 1.5 }, mixBlendMode: 'multiply' }} />
          <Typography variant="h5" component="div" sx={{ color: theme.palette.primary.main, fontWeight: 'bold', letterSpacing: 1, fontFamily: 'Roboto, sans-serif', fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, lineHeight: 1 }}>
            AYDA INDIA
          </Typography>
        </Box>

        {/* Desktop Navigation */}
        {!isMobile && (
          <Box>
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={Link}
                to={item.path}
                sx={{
                  color: isActive(item.path) ? theme.palette.primary.main : '#555',
                  fontWeight: isActive(item.path) ? 'bold' : '500',
                  mx: 1,
                  textTransform: 'none',
                  fontSize: '1rem',
                  borderBottom: isActive(item.path) ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
                  borderRadius: 0,
                  '&:hover': {
                    color: theme.palette.primary.main,
                    backgroundColor: 'transparent',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}

        {/* Mobile Navigation */}
        {isMobile && (
          <>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setDrawerOpen(true)}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            >
              <Box
                sx={{ width: 250 }}
                role="presentation"
                onClick={() => setDrawerOpen(false)}
                onKeyDown={() => setDrawerOpen(false)}
              >
                <List>
                  {navItems.map((item) => (
                    <ListItem button component={Link} to={item.path} key={item.label}>
                      <ListItemText
                        primary={item.label}
                        primaryTypographyProps={{
                          fontWeight: isActive(item.path) ? 'bold' : 'normal',
                          color: isActive(item.path) ? theme.palette.primary.main : 'inherit',
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
                <Divider />
              </Box>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
